'use client';

import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Link from 'next/link';
import { ArrowLeft, CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import ApplyJobForm from '../apply-job-form';

export default function OffPlanSpecialistPosition() {
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const offers = [
    'Uncapped Earnings: Start at 80% to 100% commission for Self lead + 50% to 70% for Company Leads',
    'Daily Flow of Fresh Qualified Leads',
    'Exclusive Inventory & Investor Network',
    'Higher Commission from Top Developers & Premium Listings',
    'Tailor-Made CRM for Dubai’s Real Estate Market',
    'In-House Media Studio & Branding Support',
    'Full Admin & Marketing Support — So You Focus on Closing Deals',
    '1-on-1 Mentorship & Growth-Oriented Coaching',
    'Visa & Medical Insurance Provided',
  ];

  const requirements = [
    'Experienced brokers ready to earn more and grow faster',
    'Fresh agents eager to learn & dominate the Dubai market',
    'Strong communicators with natural sales energy',
    'Fluent in English (other languages a plus)',
    'UAE Driving License preferred',
  ];

  return (
    <div className='bg-white dark:bg-gray-950 pt-28 pb-20'>
      <div className='container mx-auto px-4'>
        <Link
          href='/careers'
          className='inline-flex items-center text-[#fe2a53] dark:text-[#38f5ef] hover:underline mb-8'
        >
          <ArrowLeft className='w-4 h-4 mr-2' />
          Back to Careers
        </Link>

        <div className='max-w-5xl mx-auto'>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {/* Header */}
            <div className='text-center mb-12'>
              <h1 className='text-3xl md:text-4xl font-bold text-[#fe2a53] dark:text-[#38f5ef] mb-4'>
                Off-Plan Specialist
              </h1>
              <h2 className='text-2xl font-semibold text-[#fe2a53] dark:text-[#38f5ef]'>
                Dubai | 80%+ Commission
              </h2>
              <p className='mt-4 text-gray-700 dark:text-gray-300'>
                Your Future in Real Estate Starts Now!
              </p>
            </div>

            {/* What We Offer */}
            <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-lg p-6 md:p-10 mb-12'>
              <h3 className='text-xl md:text-2xl font-bold text-[#fe2a53] dark:text-[#38f5ef] mb-6 text-center'>
                What We Offer
              </h3>
              <ul className='grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700 dark:text-gray-300'>
                {offers.map((offer, idx) => (
                  <li key={idx} className='flex items-start'>
                    <CheckCircle className='w-5 h-5 text-[#fe2a53] dark:text-[#38f5ef] mt-1 mr-2 flex-shrink-0' />
                    {offer}
                  </li>
                ))}
              </ul>
            </div>

            {/* Who We’re Looking For */}
            <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-lg p-6 md:p-10 mb-12'>
              <h3 className='text-xl md:text-2xl font-bold text-[#fe2a53] dark:text-[#38f5ef] mb-6 text-center'>
                Who We’re Looking For
              </h3>
              <ul className='grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-700 dark:text-gray-300'>
                {requirements.map((req, idx) => (
                  <li key={idx} className='flex items-start'>
                    <CheckCircle className='w-5 h-5 text-[#fe2a53] dark:text-[#38f5ef] mt-1 mr-2 flex-shrink-0' />
                    {req}
                  </li>
                ))}
              </ul>
            </div>

            {/* About X-Space */}
            <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-lg p-6 md:p-10 mb-12'>
              <p className='text-gray-700 dark:text-gray-300 leading-relaxed text-center'>
                At X-Space Real Estate, we’re not just building a brokerage —
                we’re building futures. Since 2017, we’ve empowered brokers to
                unlock extraordinary success. Now, we’re looking for driven,
                high-performing agents to join our fast-growing Dubai team.
              </p>
            </div>

            {/* Apply Button */}
            <div className='text-center'>
              <Button
                onClick={() => setShowForm(true)}
                className='bg-gradient-to-r bg-primarycolor dark:bg-secondarycolor hover:bg-secondarycolor dark:hover:bg-primarycolor text-white hover:text-black dark:hover:text-white px-8 py-6 text-lg rounded-full'
              >
                Apply for this Position
              </Button>
            </div>
          </motion.div>
        </div>
      </div>

      {showForm && (
        <ApplyJobForm
          onClose={() => setShowForm(false)}
          jobTitle='Off-Plan Specialist'
        />
      )}
    </div>
  );
}
